import Footer from "@/components/Footer";
import Navigation from "@/components/Navigation";
export default function CloudCallCenterPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <section className="pt-20 bg-white relative overflow-hidden">
        <section className="relative overflow-hidden bg-gradient-to-br from-[#184fb8] via-[#1d62e6] to-[#2a7cff]">
          <div className="container mx-auto px-6 py-12 lg:py-16 text-white">
            <p className="uppercase tracking-widest text-white/80 text-xs font-semibold">
              Create better customer experience
            </p>
            <h1 className="mt-2 text-3xl md:text-4xl font-black">
              Integrate your call center software with CRM
            </h1>
            <h2 className="mt-6 text-2xl md:text-3xl font-extrabold">
              Call Center Voip Provider in Jaipur
            </h2>
            <p className="mt-4 max-w-3xl text-white/90">
              VariableSoft understands the dynamics of your customer
              relationships and what it takes to keep them engaged. Right from
              lead generation to retention, you need solutions that revolve
              around your customers’ satisfaction. Our Cloud-based offerings get
              your Cloud Contact Center up and running in no time and ensure
              that your customers’ needs are addressed throughout the customer
              life-cycle.
            </p>
          </div>
        </section>
        <main className="container mx-auto px-6 py-12 grid gap-10 lg:grid-cols-3">
          <article className="lg:col-span-2 space-y-10">
            <section className="reveal">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-900">
                Inbound Call Center Solution
              </h3>
              <ul className="mt-4 grid gap-3 sm:grid-cols-2">
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Hosted IVR</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>ACD</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Skill-based routing skills</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Priority routing</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Time-based routing</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Queue monitoring</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Barge-in &amp; call monitoring</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Real-time dashboard &amp; analytics</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Call recording</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Multi-channel communication</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>CRM integration</span>
                </li>
              </ul>
            </section>

            <section className="reveal">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-900">
                Outbound Call Center Solution
              </h3>
              <ul className="mt-4 grid gap-3 sm:grid-cols-2">
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Preview dialer</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Predictive dialer</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Progressive dialer</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Progressive dialer</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>IVR blast – SMS &amp; Voice</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Call barge-in &amp; monitoring</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Real-time dashboard &amp; analytics</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Call recording</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Multi-channel communication</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>CRM integration</span>
                </li>
              </ul>
            </section>

            <section className="reveal">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-900">
                Toll Free Number
              </h3>
              <p className="mt-3 text-slate-700">
                Having a Toll Free Number for your business allows potential
                customers to contact you without being charged for their call.
                This allows you to extend better service to your customers.
                Samvad’s Toll Free services further customer engagement through
                features such as:
              </p>
              <ul className="mt-4 grid gap-2">
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Complete call recording and management</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Customized IVR</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Detailed reporting and analytics</span>
                </li>
              </ul>
            </section>

            <section className="reveal">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-900">
                Missed Call Alert
              </h3>
              <p className="mt-3 text-slate-700">
                The concept of Missed Calls has recently redefined customer
                communications. It can be utilized to achieve multiple goals to
                generate valuable leads, interact with customers, get feedback,
                or even test a business initiative. We run end-to-end Missed
                Call Campaigns and provide complete management with:
              </p>
              <ul className="mt-4 grid gap-2">
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Customized IVR</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Bulk SMS (voice and text)</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Detailed reporting and analytics</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Complete management of customer database</span>
                </li>
                <li className="flex items-start gap-3">
                  <svg
                    className="h-5 w-5 text-[#1d62e6] mt-0.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="m5 12 4 4L19 6" />
                  </svg>
                  <span>Easy integration with all major CRM solutions</span>
                </li>
              </ul>
            </section>

            <section className="reveal">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-900">
                Voice Broad Casting
              </h3>
              <p className="mt-3 text-slate-700">
                Use Voice Broadcast to send important alerts, promotions,
                updates, and notifications to customers, employees, voters, and
                more. It’s an easy and cost-effective way to reach more people
                in less time. Voice broadcast has numerous applications spanning
                across industries. It’s simple to set up and adds a personal
                touch to your communications.
              </p>
            </section>

            <section className="reveal">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-900">
                Call Conferencing
              </h3>
              <p className="mt-3 text-slate-700">
                With reservation-less conference calling, you can host regular
                conference calls whenever you need without pre-scheduling or
                operator assistance. Your service is always active and ready to
                use—just dial your dedicated conference number and access codes
                to initiate a call.
              </p>
            </section>

            <section className="reveal">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-900">
                Cloud Call Center
              </h3>
              <p className="mt-3 text-slate-700">
                Cloud Call Center will put your outbound dialing into overdrive.
                We are fairly certain most agents don’t enjoy hand-dialing,
                leaving voicemail messages, busy tones, and spreadsheets. With
                Cloud Call Center, you can address all of these pains in an
                easy-to-use simple user interface. Spend more time having
                quality conversations and less time waiting.
              </p>
            </section>
          </article>

          <aside className="space-y-8">
            <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-[0_12px_32px_rgba(2,6,23,.10)]">
              <h4 className="text-lg font-bold text-slate-900">Services</h4>
              <ul className="mt-4 divide-y divide-slate-100">
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/webdesign">
                    Web Design
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/software-development-in-jaipur">
                    Web Development
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/ecommerce-development-services">
                    Ecommerce
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/top-software-companies-in-jaipur">
                    Mobile Application
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/it-companies-in-jaipur">
                    Digital Marketing
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/web-scraping-services">
                    Web Scraping
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/maintenanceandsupport">
                    Maintenance And Support
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/cloud-call-center">
                    Cloud Call Center
                  </a>
                </li>
                <li>
                  <a className="block py-3 hover:text-[#184fb8]" href="/ivr-system">
                    IVR System
                  </a>
                </li>
              </ul>
            </section>
          </aside>
        </main>
      </section>
      <Footer />
    </div>
  );
}
